// src/services/fieldConfigService.js

class FieldConfigService {
    constructor() {
        try {
            this.fieldConfig = JSON.parse(process.env.REACT_APP_FIELD_CONFIG || '{}');
        } catch (error) {
            console.error('Error parsing field configuration:', error);
            this.fieldConfig = {};
        }

        // Default configurations for common field types
        this.defaultConfigs = {
            date: {
                editable: false,
                type: 'datetime'  // Changed from 'date' to match FormField
            },
            system: {
                editable: false,
                type: 'text'
            }
        };
    }

    getFieldConfig(fieldKey) {
        // If there's explicit configuration, use it
        if (this.fieldConfig[fieldKey]) {
            const config = this.fieldConfig[fieldKey];

            // Normalize pick-list to select for consistency
            if (config.type === 'pick-list') {
                return {
                    ...config,
                    type: 'select'
                };
            }

            return config;
        }

        // Apply default configurations based on field patterns
        if (fieldKey.endsWith('Date')) {
            return this.defaultConfigs.date;
        }

        // System fields are typically read-only
        if (fieldKey.startsWith('System.')) {
            return this.defaultConfigs.system;
        }

        // Default fallback configuration
        return {
            editable: false,
            type: 'text'
        };
    }

    isFieldEditable(fieldKey) {
        const config = this.getFieldConfig(fieldKey);
        return config.editable || false;
    }

    getFieldType(fieldKey) {
        const config = this.getFieldConfig(fieldKey);
        return config.type || 'text';
    }

    getFieldOptions(fieldKey) {
        const config = this.getFieldConfig(fieldKey);
        return config.options || [];
    }

    getFieldPlaceholder(fieldKey) {
        const config = this.getFieldConfig(fieldKey);
        return config.placeholder || '';
    }
}

const fieldConfigServiceInstance = new FieldConfigService();
export default fieldConfigServiceInstance;